const SEARCH_STORE_KEY = 'recent_searches';
const SEARCH_RESULTS_KEY = 'search_results';
const LAST_SEARCH_KEY = 'last_search';

export const searchStore = {
  // Save search results
  saveSearchResults: (query, results) => {
    try {
      const resultsKey = `${SEARCH_RESULTS_KEY}_${query}`;
      const dataToStore = {
        query,
        results,
        timestamp: Date.now()
      };
      console.log('Saving search results:', { query, resultsCount: results.length });
      localStorage.setItem(resultsKey, JSON.stringify(dataToStore));

      const recentSearches = searchStore.getRecentSearches();
      if (!recentSearches.includes(query)) {
        recentSearches.unshift(query);
        if (recentSearches.length > 10) {
          recentSearches.pop();
        }
        localStorage.setItem(SEARCH_STORE_KEY, JSON.stringify(recentSearches));
      }
    } catch (error) {
      console.error('Error saving search results:', error);
    }
  },

  // Get stored search results
  getStoredResults: (query) => {
    try {
      const resultsKey = `${SEARCH_RESULTS_KEY}_${query}`;
      const stored = localStorage.getItem(resultsKey);
      console.log('Attempting to get stored results for:', query);
      
      if (!stored) {
        console.log('No stored results found for:', query);
        return null;
      }

      const parsedData = JSON.parse(stored);
      console.log('Found stored results:', {
        query: parsedData.query,
        resultsCount: parsedData.results.length,
        timestamp: new Date(parsedData.timestamp)
      });

      if (Date.now() - parsedData.timestamp > 30 * 60 * 1000) {
        console.log('Stored results are too old, removing...');
        localStorage.removeItem(resultsKey);
        return null;
      }

      return { query, results: parsedData.results };
    } catch (error) {
      console.error('Error getting stored results:', error);
      return null;
    }
  },

  // Get recent searches
  getRecentSearches: () => {
    try {
      const stored = localStorage.getItem(SEARCH_STORE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error getting recent searches:', error);
      return [];
    }
  },

  // Clear recent searches
  clearRecentSearches: () => {
    try {
      // Get all recent searches first
      const recentSearches = searchStore.getRecentSearches();
      
      // Remove all stored results for each search
      recentSearches.forEach(query => {
        const resultsKey = `${SEARCH_RESULTS_KEY}_${query}`;
        localStorage.removeItem(resultsKey);
      });

      // Remove the recent searches list
      localStorage.removeItem(SEARCH_STORE_KEY);
    } catch (error) {
      console.error('Error clearing searches:', error);
    }
  },

  // Save last search state
  saveLastSearch: (query, results) => {
    try {
      localStorage.setItem(LAST_SEARCH_KEY, JSON.stringify({
        query,
        results,
        timestamp: Date.now()
      }));
    } catch (error) {
      console.error('Error saving last search:', error);
    }
  },

  // Get last search state
  getLastSearch: () => {
    try {
      const stored = localStorage.getItem(LAST_SEARCH_KEY);
      if (!stored) return null;

      const data = JSON.parse(stored);
      
      // Check if less than 24 hours old
      if (Date.now() - data.timestamp > 24 * 60 * 60 * 1000) {
        localStorage.removeItem(LAST_SEARCH_KEY);
        return null;
      }

      return data;
    } catch (error) {
      console.error('Error getting last search:', error);
      return null;
    }
  },

  // Clear last search
  clearLastSearch: () => {
    localStorage.removeItem(LAST_SEARCH_KEY);
  }
}; 